export const themeColors = {
  green900: '#103c2b',
  green700: '#0c533c',
  green500: '#07694d',
  green300: '#6fb09e',
  gold900:  '#8A5414',
  gold700:  '#C8842A',
  gold500:  '#E6B95F',
  gold300:  '#F7EED9',
  gray900:  '#2d2d2d',
  gray700:  '#6f6f6f',
  gray600:  '#909090',
  gray500:  '#cccccc',
  gray400:  '#ececec',
  gray300:  '#f2f2f2',
  gray100:  '#f6f6f6',
  graycore: '#000000',
  white:    '#FFFFFF',
  redBase:  '#E11D48',
  redText:  '#E11D48',
  red:      '#E11D48',  // legacy alias → redBase
  warning:  '#C8842A',  // maps to $gold700
}
